<template>
	<div class="grid grid-nogutter surface-section text-800 m-0 p-0">
		<div class="col-12 md:col-5 p-6 text-center md:text-left flex align-items-center justify-content-center">
			<section>
				<div class="text-7xl text-primary font-bold">PowerX</div>
				<span class="block text-3xl font-bold mb-3">Solar</span>
				<!-- <p class="mt-0 mb-4 text-700 line-height-3"></p> -->
				<form
					@submit.prevent="doLogin()"
					ref="login-form"
				>
					<div>
						<label
							class="block text-900 font-medium mb-2"
							for="username1"
						>Username</label>
						<PInputText
							autocomplete="username"
							class="w-full mb-3"
							id="username1"
							type="text"
							v-model="username"
						/>

						<label
							class="block text-900 font-medium mb-2"
							for="password1"
						>Password</label>
						<PInputText
							autocomplete="current-password"
							class="w-full mb-3"
							id="password1"
							type="password"
							v-model="password"
						/>

						<PButton
							:loading="loading"
							class="p-button-raised w-full mt-3"
							label="Sign In"
							type="submit"
						></PButton>

						<p class="mt-4 mb-0 text-600 text-sm text-center">
							Powered by
							<a
								class="text-primary no-underline font-medium"
								href="https://craftdar.com"
								rel="noopener noreferrer"
								target="_blank"
							>Craftdar</a>
						</p>
					</div>
				</form>
			</section>
		</div>
		<div class="col-12 md:col-7 overflow-hidden p-0 m-0">
			<img
				alt="Login"
				class="md:ml-auto block md:h-full"
				src="@/assets/images/login-hero.jpg"
				style="clip-path: polygon(8% 0%, 100% 0%, 100% 100%, 0 100%); max-height: 97vh;"
			/>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Utils from '@/utils/Utils'
	import AuthManager from '@/utils/AuthManager'

	export default defineComponent({
		data() {
			return {
				loading: false,
				username: '',
				password: '',
			}
		},
		methods: {
			async doLogin() {
				// Validate the inputs
				if (this.username.trim() === '' || this.password === '') {
					Utils.showErrorMessage('Please enter Username and Password')
					return
				}

				this.loading = true
				try {
					const ok = await AuthManager.login(this.username.trim(), this.password)
					if (ok) {
						Utils.navigateTo('/', true)
					} else {
						Utils.showErrorMessage('Username and/or Password did not match our records!')
					}
				} catch (error) {
					Utils.showErrorMessage('Username and/or Password did not match our records!')
				} finally {
					this.loading = false
				}
			},
		}

	})
</script>
